import API_INTERFACE_URI from "../constants/uri.constants";
import baseService from "./service";
import {globalHeaders} from "../utilities/http";

function getFfrStatus(ffrNumber, destLocCode) {
    let filters = [];
    let params = [];
    
    if (ffrNumber) {
        filters.push(`ffrNumber(${ffrNumber})`);
    }
    if (destLocCode) {
        filters.push(`destination_location_code(${destLocCode})`);
    }
    
    if (filters.length > 0) {
        params.push(`filters=${filters.join(",")}`);
    }
    
    let url = API_INTERFACE_URI.FFR_STATUS;
    url = url + "?" + params.join("&");
    return baseService.get(url, globalHeaders);
}

function downloadFfrPayload(ffrNumber, destLocCode, type) {
    let filters = [];
    let params = [];
    
    if (ffrNumber) {
        filters.push(`ffrNumber(${ffrNumber})`);
    }
    if (destLocCode) {
        filters.push(`destination_location_code(${destLocCode})`);
    }
    
    if (filters.length > 0) {
        params.push(`filters=${filters.join(",")}`);
    }
    
    params.push(`type=${type}`);
    params.push(`mode=content`);
    
    let url = API_INTERFACE_URI.FFR_DOWNLOAD;
    url = url + "?" + params.join("&");
    return baseService.get(url, globalHeaders);
}

function getFfrErrorLogsUrl(ffrNumber, env, geo, timeRange = '-7d') {
    let params = [];
    if (ffrNumber) params.push(`ffrNumber=${ffrNumber}`);
    if (env) params.push(`env=${env}`);
    if (geo) params.push(`geo=${geo}`);
    params.push(`timeRange=${timeRange}`);

    let url = API_INTERFACE_URI.FFR_ERROR_LOGS_URL;
    url = url + "?" + params.join("&");
    return baseService.get(url, globalHeaders);
}

export const FfrStatusService = {
    getFfrStatus,
    downloadFfrPayload,
    getFfrErrorLogsUrl
};
